import { Box, Chip } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { EnforcementState } from "~/operations";
import { PolicyCheckNode } from "../../types";

export function ChecksTableStatusCell(
  params: GridRenderCellParams<PolicyCheckNode, string>,
) {
  const state = params.value || EnforcementState.Enforcing;

  // Map state to display label
  const getStatusLabel = (state: string) => {
    if (state === EnforcementState.Preview) {
      return "PREVIEW";
    }
    return "SCORED";
  };

  const getStatusColor = (state: string) => {
    if (state === EnforcementState.Preview) {
      return {
        backgroundColor: "action.hover",
        color: "text.secondary",
      };
    }
    return {
      backgroundColor: "transparent",
      color: "none.main",
      border: "1px solid",
      borderColor: "none.main",
    };
  };

  const statusLabel = getStatusLabel(state);
  const statusColor = getStatusColor(state);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        height: "100%",
      }}
    >
      <Chip
        label={statusLabel}
        size="small"
        sx={{
          fontSize: 12,
          fontWeight: 700,
          borderRadius: 1,
          ...statusColor,
        }}
      />
    </Box>
  );
}
